import { logCoreUsage } from 'owa-analytics';
import type { WindowKey } from 'owa-bizchat-types';
import type { MailboxInfo } from 'owa-client-types';
import { getSurfacedAsyncItems } from '../selectors/getSurfacedAsyncItems';
import { isActive } from '../selectors/isActive';
import { getTasksHubBacklog } from './getTasksHubBacklog';
import { consumeTimeInHubMs } from './tasksHubVisitClock';

export type TasksHubCloseReason = 'drawerClosed' | 'switchedViaMenu' | 'openedConversation';

export function logTasksHubClosed(
    windowKey: WindowKey,
    mailboxInfo: MailboxInfo,
    reason: TasksHubCloseReason,
    openedItemId?: string
): void {
    if (!isActive(windowKey)) {
        return;
    }

    const remaining = getSurfacedAsyncItems(mailboxInfo).filter(
        ({ entry }) => entry.id !== openedItemId
    );

    logCoreUsage('AsyncChat_TasksHubClosed', mailboxInfo, {
        reason,
        timeInHubMs: consumeTimeInHubMs(windowKey),
        ...getTasksHubBacklog(remaining),
    });
}
